var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "header-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon small filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg",
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800",
    attrs: {
      "id": "Client-name"
    }
  }, [_vm._v("Faktúra & objednávateľ")])]), _c('button', {
    staticClass: "button-primary-expert w-button"
  }, [_vm._v(" Uložiť ")])]), _c('div', {
    staticClass: "content-form-popup noselect",
    attrs: {
      "data-w-id": "d3c42ea8-0e05-8060-b016-22f1a2f40311"
    }
  }, [_c('div', {
    staticClass: "dropdown-input-custom"
  }, [_c('input', {
    staticStyle: {
      "opacity": "0",
      "position": "absolute"
    },
    attrs: {
      "type": "text",
      "required": ""
    }
  }), _c('dropdown-select', {
    attrs: {
      "id": 'orderer',
      "init-value": _vm.form.orderer,
      "options": _vm.personChoices,
      "normal": "",
      "name": 'Profesia'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'orderer');
      }
    }
  })], 1), _c('contact-person-form'), _c('div', {
    staticClass: "dropdown-input-custom mt-4"
  }, [_c('input', {
    staticStyle: {
      "opacity": "0",
      "position": "absolute"
    },
    attrs: {
      "type": "text",
      "required": ""
    }
  }), _c('dropdown-select', {
    attrs: {
      "id": 'contactPerson',
      "init-value": _vm.form.contactPerson,
      "options": _vm.personChoices,
      "normal": "",
      "name": 'Profesia'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'contactPerson');
      }
    }
  })], 1), _vm.form.contactPerson ? _c('contact-person-form') : _vm._e()], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }